const REMOTE_ENDPOINT = 'https://api-wslk74zzgq-uc.a.run.app';
const LOCAL_ENDPOINT = 'http://localhost:8084/';
const DEV_LOCAL = false;
export const GQL_ENDPOINT = DEV_LOCAL ? LOCAL_ENDPOINT : REMOTE_ENDPOINT;
